/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SearchZendeskResponse,
    SearchZendeskResponseFromJSON,
    ZendeskSearchBody,
    ZendeskSearchBodyToJSON,
} from '../models';

export interface SearchApiSearchzendeskPostRequest {
    zendeskSearchBody: ZendeskSearchBody;
}

/**
 *
 */
export class ZendeskSearchApi extends runtime.BaseAPI {

    /**
     * Search
     */
    async searchApiSearchzendeskPostRaw(requestParameters: SearchApiSearchzendeskPostRequest): Promise<runtime.ApiResponse<SearchZendeskResponse>> {
        if (requestParameters.zendeskSearchBody === null || requestParameters.zendeskSearchBody === undefined) {
            throw new runtime.RequiredError('zendeskSearchBody','Required parameter requestParameters.zendeskSearchBody was null or undefined when calling searchApiSearchzendeskPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/searchzendesk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ZendeskSearchBodyToJSON(requestParameters.zendeskSearchBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchZendeskResponseFromJSON(jsonValue));
    }

    /**
     * Search
     */
    async searchApiSearchzendeskPost(requestParameters: SearchApiSearchzendeskPostRequest): Promise<SearchZendeskResponse> {
        const response = await this.searchApiSearchzendeskPostRaw(requestParameters);
        return await response.value();
    }

}
